// used to check for cart limits on products in cart.js and minicart.js
window.cartLimit = 12;

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
    callback.apply(null, args);
    }, wait);
  };
}

function trapFocus(modal) {
  const focusableSelectors = `
    a[href], area[href], input:not([disabled]),
    select:not([disabled]), textarea:not([disabled]),
    button:not([disabled]), [tabindex]:not([tabindex="-1"])`;
  const focusableElements = Array.from(modal.querySelectorAll(focusableSelectors));

  if (focusableElements.length === 0) {
    console.warn('No focusable elements found in the modal.');
    return;
  }

  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  function handleFocusTrap(event) {
    const isTabPressed = event.key === 'Tab';

    if (!isTabPressed) return;
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        event.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        event.preventDefault();
      }
    }
  }
  modal.addEventListener('keydown', handleFocusTrap);
  firstFocusableElement.focus();
  firstFocusableElement.blur();
  
  return function cleanupFocusTrap() {
    modal.removeEventListener('keydown', handleFocusTrap);
  };
}

function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
      var result = fn();
      if(result) {
        resolve(result);
      }
      else if (Number(new Date()) < endTime) {
        setTimeout(checkCondition, interval, resolve, reject);
      }
      else {
          reject(new Error('timed out for ' + fn + ': ' + arguments));
      }
  };

  return new Promise(checkCondition);
}

const __isp_get_customer_identifier_from_klaviyo = () => {
  try {
    const customer_id = _learnq.push(['_getIdentifiers']).$exchange_id;
    if (typeof customer_id !== 'undefined') {
      return customer_id;
    }
    return '';
  } catch (e){
    return '';
  }
}

// CUSTOM PARSER ========================
class CustomParser extends HTMLElement {
  connectedCallback() {
    this.style.whiteSpace = 'pre-wrap';
    const textArea = document.createElement('textarea');
    textArea.innerHTML = this.innerHTML;
    const parsedString = textArea.value;
    this.innerHTML = parsedString;
  }
}

customElements.define('dom-parser', CustomParser);
// END CUSTOM PARSER ========================


function shuffle(array) {
  let currentIndex = array.length, randomIndex;

  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

function toHandle(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Sticky scroll-up header
let header = document.querySelector('header');
let lastScrollTop = 0;

let scrollDistance = 0;

window.addEventListener('scroll', () => {
  const currentScroll = window.scrollY || document.documentElement.scrollTop;
  const scrollDirection = currentScroll > lastScrollTop ? 'down' : 'up';
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  const mainContent = document.querySelector('#MainContent');

  if (scrollDirection === 'down') {
      scrollDistance += currentScroll - lastScrollTop;
      if (scrollDistance >= 200) {
        header.closest('.shopify-section').classList.add('-translate-y-[200%]');
        document.documentElement.style.setProperty('--header-height', `0px`);
        document.documentElement.style.setProperty('--full-header-height', `0px`);

      }
  } else {
      header.closest('.shopify-section').classList.remove('-translate-y-[200%]');
      scrollDistance = 0;
      
      const headerFullGroup = [...document.querySelectorAll('.section-header')].reduce((sum, el) => sum + el.offsetHeight, 0);
      const thinPromoBanner = document.querySelector('.thin-promo-banner');
      const thinPromoBannerHeight = (window.scrollY === 0 && thinPromoBanner) ? thinPromoBanner.offsetHeight : 0;
      const totalHeaderHeight = headerFullGroup + thinPromoBannerHeight;
      document.documentElement.style.setProperty('--full-header-height', `${totalHeaderHeight}px`);

      if (headerGroup) {
          document.documentElement.style.setProperty('--header-height', `${mainContent.getBoundingClientRect().top}px`);
      }
  }

  if (headerGroup) {
    if (currentScroll < 200) {
      document.body.classList.add('at-top');
    } else {
      document.body.classList.remove('at-top');
    }
  }

  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
});

function updateMainContentOffset() {
  const mainContent = document.querySelector('#MainContent');
  if (mainContent) {
    const offsetTop = mainContent.getBoundingClientRect().top + window.scrollY;
    const scrollTop = window.scrollY;
    const value = scrollTop > offsetTop ? 0 : offsetTop;
    document.documentElement.style.setProperty('--desktop-top', `${value}px`);
  }
}

window.addEventListener('load', updateMainContentOffset);
window.addEventListener('resize', updateMainContentOffset);
window.addEventListener('scroll', updateMainContentOffset);

document.getElementById('signupSumbit').addEventListener('click', (e) => {
  const emailError = document.getElementById('signupError');
  let state = e.target.getAttribute("type")
  if (state == 'button') {
    emailError.classList.remove('hidden')
  }
});

document.addEventListener('resize', () => {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (!headerGroup) return;
  document.documentElement.style.setProperty('--header-height', `${headerGroup?.offsetHeight}px`);
});

(() => {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (!headerGroup) return;
  document.documentElement.style.setProperty('--header-height', `${headerGroup?.offsetHeight}px`);
  const headerFullGroup = [...document.querySelectorAll('.section-header')].reduce((sum, el) => sum + el.offsetHeight, 0);
  const thinPromoBanner = document.querySelector('.thin-promo-banner');
  const thinPromoBannerHeight = (window.scrollY === 0 && thinPromoBanner) ? thinPromoBanner.offsetHeight : 0;
  const totalHeaderHeight = headerFullGroup + thinPromoBannerHeight;
  document.documentElement.style.setProperty('--full-header-height', `${totalHeaderHeight}px`);
}) ();

//Force cart update on back button
window.addEventListener('pageshow', (event) => {
  setTimeout(function(){
    const mini_cart = document.querySelector('mini-cart');
    mini_cart.updateCartHtml();
  }, 100);
});


document.addEventListener('DOMContentLoaded', function() {
  const parallaxContainers = document.querySelectorAll('.parallax-container');

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;

    parallaxContainers.forEach(container => {
      const parallaxImages = container.querySelectorAll('.parallax-image');
      const containerTop = container.offsetTop + 70;

      if (scrollY >= containerTop) {
        parallaxImages.forEach(image => {
          const offset = (scrollY - containerTop) * 0.25;
          image.style.transform = `translateY(${offset}px)`;
        });
      } else {
        parallaxImages.forEach(image => {
          image.style.transform = 'translateY(0px)';
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const handleReviewClick = (e) => {
    e.preventDefault();
    document.querySelector('.pr-block')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (!mutation.addedNodes) continue;
      const reviewLink = document.querySelector('.pr-snippet-review-count');
      if (reviewLink) {
        observer.disconnect();
        const newLink = reviewLink.cloneNode(true);
        reviewLink.replaceWith(newLink);
        newLink.addEventListener('click', handleReviewClick);
        break;
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

window.addEventListener('dataLayer:color_change', () => {
  setTimeout(() => {
    const item = JSON.parse(document.getElementById("_learnq_item").innerHTML);
    window._learnq?.push(['track', 'Viewed Product', item]);
    window._learnq?.push(['trackViewedItem', {
      Title: item.Name,
      ItemId: item.ProductID,
      Categories: item.Categories,
      ImageUrl: item.ImageURL,
        Url: item.URL,
        Tags: item.tags,
        Metadata: {
        Brand: item.Brand,
        Price: item.Price,
        CompareAtPrice: item.CompareAtPrice
      } 
    }]);
  }, 100);
});

window.addEventListener('dataLayer:size_select', e => {
  let { selected, current } = e.detail;
  selected = JSON.parse(selected);
  elevarDataLayer('size_select', selected, current);
});

window.addEventListener('dataLayer:color_change', e => {
  let { selected, current } = e.detail;
  selected = JSON.parse(selected);
  elevarDataLayer('color_change', selected, current);  
});

function elevarDataLayer(eventName, selected, current) {
  const cat = localStorage.getItem("___ELEVAR_GTM_SUITE--lastCollectionPathname");
  dataLayer.push({event: 'pageview'});
  dataLayer.push({
    'event': 'dl_view_item_' + eventName,
    'ecommerce': {
      'currencyCode': "USD",
      'detail': {
        'actionField': {
          'list': cat != null ? cat : ''
        },
        'products': [{
          'name': selected.title,
          'id': current.sku,
          'price': String(selected.price / 100),
          'compare_at_price': String(selected.compare_at_price / 100),
          'image': selected.featured_image,
          'brand': selected.brand,
          'list': cat != null ? cat : '',
          'category': selected.type,
          'product_id': selected.id,
          'variant': current.title,
          'variant_id': current.id
        }]
      }
    }
  });
}

const banner = document.getElementById('consent_banner');
const closeBtn = document.getElementById('consent_banner_close');

if (sessionStorage.getItem('consent_banner_closed') !== 'true')  banner?.classList.remove('hidden');

closeBtn?.addEventListener('click', () => {
  sessionStorage.setItem('consent_banner_closed', 'true');
  banner?.classList.add('hidden');
});